<template>
  <div class="karyawan-search-select position-relative">
    <input
      type="text"
      class="form-control"
      :placeholder="placeholder"
      v-model="query"
      @input="onInput"
      @focus="showDropdown = true"
      @blur="onBlur"
      autocomplete="off"
    >
    <div class="karyawan-search-dropdown" v-if="showDropdown && results.length">
      <div
        v-for="row in results"
        :key="row.id_karyawan"
        class="karyawan-search-item"
        @mousedown.prevent="select(row)"
      >
        <span class="d-block text-sm font-weight-bold">{{ row.nama }}</span>
        <span class="text-secondary text-xs">{{ row.id_karyawan }} &middot; {{ row.jabatan }} &middot; {{ row.unit }}</span>
      </div>
    </div>
    <div class="karyawan-search-dropdown" v-else-if="showDropdown && query.trim().length >= 2 && !loading && searched">
      <div class="karyawan-search-item text-secondary text-sm">Karyawan tidak ditemukan</div>
    </div>
  </div>
</template>

<script>
import Api from '@/helpers/api';
import dataKaryawan from '@/services/dataKaryawan.service';

// Typeahead for picking an employee by NAME instead of typing a raw
// id_karyawan -- Admin usually doesn't know the ID offhand. Emits the
// chosen id_karyawan via v-model; the visible input just shows the name.
// Used by DataAbsensi.vue's Add Attendance Log / Add Lembur / Add Cuti-Sakit
// forms, so this lives as a shared component rather than duplicated 3x.
export default {
  name: 'karyawan-search-select',
  props: {
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: 'Ketik nama karyawan...' },
    // Display name for an id_karyawan the parent already has (edit mode) --
    // this component only knows an id via modelValue, not the name that
    // goes with it, so the parent passes the name it already fetched.
    label: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      query: '',
      results: [],
      showDropdown: false,
      loading: false,
      searched: false,
      debounceTimer: null,
    };
  },
  watch: {
    modelValue(newVal) {
      // Parent reset its data object back to {} (e.g. after save, or
      // opening the form fresh for a new entry) -- clear our own display
      // text too, since the component instance stays mounted/reused across
      // modal open/close (vue-final-modal toggles visibility, not v-if).
      if (!newVal) {
        this.query = '';
        this.results = [];
      }
    },
    label(newVal) {
      if (newVal) {
        this.query = newVal;
      }
    },
  },
  mounted() {
    if (this.label) {
      this.query = this.label;
    }
  },
  methods: {
    onInput() {
      this.$emit('update:modelValue', '');
      this.searched = false;
      clearTimeout(this.debounceTimer);
      if (this.query.trim().length < 2) {
        this.results = [];
        return;
      }
      this.debounceTimer = setTimeout(() => this.search(), 300);
    },
    onBlur() {
      // Delay so a dropdown-item mousedown still registers before this
      // closes it (blur fires before click otherwise).
      setTimeout(() => { this.showDropdown = false; }, 150);
    },
    search() {
      let context = this;
      context.loading = true;
      Api(context, dataKaryawan.index({ nama: context.query })).onSuccess(function(response) {
        context.results = response.data.data.data || [];
      }).onError(function() {
        context.results = [];
      }).onFinish(function() {
        context.loading  = false;
        context.searched = true;
      })
      .call();
    },
    select(row) {
      this.query        = row.nama;
      this.results       = [];
      this.showDropdown  = false;
      this.$emit('update:modelValue', row.id_karyawan);
    },
  },
};
</script>
<style scoped>
.karyawan-search-dropdown {
  position: absolute;
  z-index: 1100;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  margin-top: 2px;
}
.karyawan-search-item {
  padding: 8px 12px;
  cursor: pointer;
}
.karyawan-search-item:hover {
  background-color: #f0f8ff;
}
</style>
